import type {ReactElement} from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import styles from './ai-prompt-box-snackbar.module.scss';
import type {AiPromptBoxSnackbarProps, AnimatedAiPromptBoxSnackbarProps} from './ai-prompt-box-snackbar.types';
import {Text, TextSize} from '@Components/text';

const SNACKBAR_GAP_PX = 8;

export function AiPromptBoxSnackbar({text, className}: AiPromptBoxSnackbarProps): ReactElement {
  return (
    <div className={`${styles.snackbar} ${className ?? ''}`}>
      <Text size={TextSize.MD} val={text} className={styles.text} />
    </div>
  );
}

/**
 * Slides the snackbar up from behind its container — the consumer positions it with `bottom: 100%`,
 * and the animation translates it from "fully tucked behind the container" up to `gap` pixels above.
 * Pair with `z-index: -1` on the container so the snackbar is occluded by the prompt box during the slide.
 */
export function AnimatedAiPromptBoxSnackbar({text, className, visible}: AnimatedAiPromptBoxSnackbarProps): ReactElement {
  return (
    <AnimatePresence>
      {visible ? (
        <motion.div
          initial={{opacity: 0, y: '100%'}}
          animate={{opacity: 1, y: -SNACKBAR_GAP_PX}}
          exit={{opacity: 0, y: '100%'}}
          transition={{duration: 0.25, ease: 'easeOut'}}
          className={className}
        >
          <AiPromptBoxSnackbar text={text} />
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
